import {
  ActionTabItem,
  largeNuggetVariantMapper,
  getTypeChipPropsForVariant,
  ContentNugget,
} from '@backrs_ui/common-ui';

import { useGetNuggetActionParams } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.hook';
import {
  determineTitle,
  determineSubtitle,
  determineDescription,
  nuggetMapper,
} from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';

import { NuggetPageContent } from '../NuggetPage/NuggetPageContent';

type IndustryPageProps = Readonly<{
  nugget: ContentNugget;
}>;

export const IndustryPage = ({ nugget }: IndustryPageProps) => {
  const { actionParams } = useGetNuggetActionParams(nugget);

  const title = determineTitle(nugget);
  const subtitle = determineSubtitle(nugget) || '';
  const description = determineDescription(nugget);

  const nuggetVariant = nuggetMapper({ nugget });
  const { component } = largeNuggetVariantMapper(nuggetVariant);

  const buttonGroup: ActionTabItem[] = [];

  if (actionParams?.handleActionBookmark) {
    buttonGroup.push({
      label: actionParams.hasBookmarked ? 'Saved' : 'Save',
      onClick: actionParams.handleActionBookmark,
      icon: actionParams.hasBookmarked ? 'BookmarkCheck' : 'Bookmark',
    });
  }

  if (actionParams?.handleActionShare) {
    buttonGroup.push({
      label: 'Share',
      onClick: actionParams.handleActionShare,
      icon: 'Share06',
      tooltipOnClickText: 'Link copied!',
    });
  }

  const typeChipProps = getTypeChipPropsForVariant(nuggetVariant);

  return (
    <NuggetPageContent
      title={title}
      subtitle={subtitle}
      description={description}
      children={component}
      buttonGroup={buttonGroup}
      typeChipProps={typeChipProps}
    />
  );
};
